import { defineStore } from "pinia"

export const usuarioStore = defineStore("usuario", {
  actions: {
    verificarSeUsuarioConsentiuComCookies(): boolean | null {
      try {
        const consentimento = localStorage.getItem("consentimentoDeMonitoramento")

        switch (consentimento) {
          case 'negado':
            return false
          case 'aceito':
            return true
          default:
            return null
        }
      } catch (erro) {
        return null
      }
    }

  }
})
